import React, { useState } from "react";
import { Link } from "react-router-dom";
import CompCategories from "./CompCategories";
import CompFormats from "./CompFormats";
import CompClasses from "./CompClasses";
import Countries from "./Countries";
import Levels from "./levels";
import Gender from "./Gender";

const CompSettingsTabs = () => {

    const [activeTab, setActiveTab] = useState("Competition Categories");

    const tabData = [
        {
            icon: <i className="fas fa-tags" />,
            name: "Competition Categories",
            content: <CompCategories />
        },
        {
            icon: <i className="fas fa-diagram-project" />,
            name: "Competition Formats",
            content: <CompFormats />
        },
        {
            icon: <i className="fas fa-layer-group" />,
            name: "Competition Classes",
            content: <CompClasses />
        },
        {
            icon: <i className="fas fas fa-flag-checkered" />,
            name: "Countries",
            content: <Countries />
        },
        {
            icon: <i className="fas fa-arrow-trend-up" />,
            name: "Levels",
            content: <Levels />
        },
        {
            icon: <i className="fas fa-mars-and-venus" />,
            name: "Gender",
            content: <Gender />
        },
        {
            icon: <i className="fas fa-list-check" />,
            name: "Result Format",
            content: ""
        },
    ]
    return (
        <>
            <div className="content container" style={{ maxWidth: "1500px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row d-flex align-items-center">
                                <div className="col-xl-12 col-lg-12 col-sm-12 col-md-12">
                                    <div className="coach-court-list">
                                        <ul className="nav">
                                            {tabData.map((tab, i) => (
                                                <li key={i}>
                                                    <Link
                                                        to="#"
                                                        className={tab.name === activeTab ? "active" : ""}
                                                        onClick={() => setActiveTab(tab.name)}
                                                    >
                                                        {tab.icon} {tab.name}
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                                <div className="tab-content">
                                    {tabData
                                        .filter(tab => tab.name === activeTab)
                                        .map((tab, i) => (
                                            <div key={i}>{tab.content}</div>
                                        ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CompSettingsTabs;